import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { filterRequest } from "../../utilities/apiManager";
import axiosInstance from "../../utilities/axiosInstance";

let initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
}

export const getAdminExpenses = createAsyncThunk(
  "adminExpenses/getAdminExpenses",
  async (args, thunkApi) => {
    try {
      const { page, size = 10, query } = args;
      const filter = filterRequest(args.filter);
      const { data } = await axiosInstance.get(
        `/admin_expenses?page=${page}&size=${size}&query=${query}${filter}`
      );
      return thunkApi.fulfillWithValue(data);
    } catch (errors) {
      console.log(errors);
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const createAdminExpense = createAsyncThunk(
  "adminExpenses/createAdminExpense",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(
        `/admin_expenses`,
        args
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const updateAdminExpense = createAsyncThunk(
  "adminExpenses/updateAdminExpense",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.put(
        `/admin_expenses/${args._id}`,
        args.values
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

export const deleteAdminExpense = createAsyncThunk(
  "adminExpenses/deleteAdminExpense",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.delete(
        `/admin_expenses/${args._id}`
      );
      return thunkApi.fulfillWithValue(data);
    }
    catch (errors) {
      return thunkApi.rejectWithValue(errors.response.data);
    }
  }
);

const adminExpensesSlice = createSlice({
  name: "adminExpenses",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAdminExpenses.pending, (state) => {
        state.isLoading = true;
        state.error = null
      })
      .addCase(getAdminExpenses.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.error = null;
        state.data = payload.data;
        state.itemsCount = payload.itemsCount;
        state.pages = payload.pages;
      })
      .addCase(getAdminExpenses.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(createAdminExpense.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createAdminExpense.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data.push(payload.data);
        state.itemsCount++;
        state.error = null;
      })
      .addCase(createAdminExpense.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(updateAdminExpense.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateAdminExpense.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        const indexAt = state.data.findIndex(el => el._id === payload.data._id);
        state.data[indexAt] = payload.data;
        state.error = null;
      })
      .addCase(updateAdminExpense.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })

      .addCase(deleteAdminExpense.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(deleteAdminExpense.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.data = state.data.filter(el => el._id !== payload.data._id);
        state.error = null;
      })
      .addCase(deleteAdminExpense.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.error = payload?.message;
      })
  }
});

export default adminExpensesSlice.reducer;